import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextComponent } from 'src/app/_shared/components/input-text/input-text.component';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeBaseComponent } from 'src/app/_core';
import { RestorePasswordFormService } from 'src/app/routes/auth/forms/restore-password.form';
import { ModalRestorePasswordSummaryComponent } from 'src/app/routes/auth/modals/modal-restore-password-summary/modal-restore-password-summary.component';
import { AuthService } from 'src/app/routes/auth/state/auth.service';
import { AccButtonComponent } from 'src/app/_shared/components/acc-button/acc-button.component';
import { IconButtonComponent } from 'src/app/_shared/components/icon-button/icon-button.component';
import { LoaderDirective } from 'src/app/_shared/directives/loader.directive';
import {
  CustomOverlayRef,
  CUSTOM_OVERLAY_DATA,
  OverlayService,
} from 'src/app/_core/services/overlay.service';

@Component({
  standalone: true,
  selector: 'neopos-modal-restore-password',
  templateUrl: './modal-restore-password.component.html',
  styles: [
    `
      :host {
        display: block;
        width: -webkit-fill-available;
        overflow: hidden;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    IconButtonComponent,
    InputTextComponent,
    LoaderDirective,
    AccButtonComponent,
  ],
})
export class ModalRestorePasswordComponent
  extends ThemeBaseComponent
  implements OnInit, OnDestroy
{
  private readonly _restorePasswordFormService = inject(
    RestorePasswordFormService
  );
  private readonly _dialogRef = inject(CustomOverlayRef);
  private readonly _data = inject(CUSTOM_OVERLAY_DATA);
  private readonly _overlayService = inject(OverlayService);
  private readonly _authService = inject(AuthService);

  private _mutationRequestPasswordReset =
    this._authService.requestPasswordReset();
  readonly mutationRequestPasswordReset = toSignal(
    this._mutationRequestPasswordReset.result$
  );

  restorePasswordFormVM = this._restorePasswordFormService.vm;

  ngOnInit(): void {
    if (this._data?.currentEmail) {
      const { email } = this.restorePasswordFormVM.controls;

      email.setValue(this._data.currentEmail);
      email.disable();
    }
  }

  ngOnDestroy(): void {
    this._restorePasswordFormService.resetForm();
  }

  close = () => this._dialogRef.close();

  onRestorePassword(): void {
    if (this._restorePasswordFormService.canSubmitForm()) {
      this._mutationRequestPasswordReset
        .mutate(this.restorePasswordFormVM.getRawValue().email)
        .then(() => {
          this.close();

          this._overlayService.open(
            {
              width: 434,
              hasBackdrop: true,
              backdropClass: 'backdrop-style',
              responsive: true,
              data: {
                loggedUser: !!this._data?.currentEmail,
              },
            },
            ModalRestorePasswordSummaryComponent
          );
        });
    }
  }
}
